'use client';

import { useEffect, useRef } from 'react';

import { trackNaverCtsConversion } from '@/utils/analytics/naver-cts';

export const NaverCtsTransTrigger = (
  transOption: Parameters<Window['wcs']['trans']>[0],
) => {
  const hasTrackedRef = useRef(false);

  //* 이탈해도 전환은 유효해야 하므로(GTM과 동일 의미론) cleanup으로 취소하지 않는다
  useEffect(() => {
    if (hasTrackedRef.current) {
      return;
    }

    hasTrackedRef.current = true;
    trackNaverCtsConversion(transOption);
  }, [transOption]);

  return null;
};
